import { Brand } from "@/components/brand";

/** Pantallas sin menú (login, selector, sin acceso, conectar el Mac). */
export const CenteredScreen = ({ children }: { children: React.ReactNode }) => (
  <main className="flex min-h-screen flex-col items-center justify-center gap-8 bg-muted p-4">
    <Brand />
    <div className="w-full max-w-md">{children}</div>
  </main>
);
